import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginApi } from "../services/Api";
import { GenerateToken } from "../services/Firebase";

const SignIn = ({onButtonPress}) => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [token,setToken] = useState('');
  const [error, setError] = useState(""); // For displaying errors
  const navigate = useNavigate();

  const handleToken = async()=>{
    const token = await GenerateToken();
    if(token) 
    {
      setToken(token);
    }
  }

  // Input validation function
  const validateInputs = () => {
    if (!phone.trim()) {
      setError("Phone number is required.");
      return false;
    }
    if (!/^\d{10}$/.test(phone)) {
      setError("Invalid phone number. It must be 10 digits.");
      return false;
    }
    if (!password.trim()) {
      setError("Password is required.");
      return false;
    }
    setError(""); // Clear any previous errors
    return true;
  };

  // Async function to handle sign-in
  const handleSignIn = async () => {
    // await handleToken();
    if (validateInputs()) {
      const response = await LoginApi({
        phoneNumber: phone,
        password: password,
      });
      console.log('LoginApi response:',response);

      // Store response data in localStorage
      if (response.status === 'success') {
        localStorage.setItem("userData", JSON.stringify(response.data));
        setError(response.message);
        navigate("/", { replace: true });
      }
      else if(response.status === "failure"){
        setError(response.message);
      }
    }
    else{
      return;
    }
  };

  const handleForgotPass=async()=>{
    const flag = true;
    navigate("/forgotPass", { state: { flag } });
  }

  return (
    <div className="sign-in-container">
      
      <input
        className="input-field"
        type="tel"
        placeholder="Enter your phone number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        maxLength={10}
      />
      <input
        className="input-field"
        type="password"
        placeholder="Enter your password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button className="submit-button" onClick={handleSignIn}>
        <h2 className="submit-text">Sign In</h2>
      </button>
      <button className="forgot-password" onClick={handleForgotPass}>Forgot Password</button>
      <button className="create-new-account" onClick={onButtonPress}>Create new account</button>
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default SignIn;
